module.exports = __webpack_public_path__ + "static/magician-04-fac32bf46ceec1b0d49e073b1d2396b5.png";